import React, { useState, useCallback } from 'react';
import Stepper from './components/Stepper';
import StepService from './components/StepService';
import StepDate from './components/StepDate';
import StepTime from './components/StepTime';
import StepForm from './components/StepForm';
import SuccessPage from './components/SuccessPage';
import logo from './styles/Logo.svg';

const STEPS = [
    { num: 1, label: 'Сервис' },
    { num: 2, label: 'Дата' },
    { num: 3, label: 'Время' },
    { num: 4, label: 'Данные' },
];

export default function App() {
    const [step, setStep] = useState(1);
    const [service, setService] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);
    const [bookingResult, setBookingResult] = useState(null);

    const goToStep = useCallback((target) => {
        if (target < step) setStep(target);
    }, [step]);

    const handleServiceSelect = (svc) => {
        setService(svc);
        setSelectedDate(null);
        setSelectedTime(null);
        setStep(2);
    };

    const handleDateSelect = (date) => {
        setSelectedDate(date);
        setSelectedTime(null);
        setStep(3);
    };

    const handleTimeSelect = (time) => {
        setSelectedTime(time);
        setStep(4);
    };

    const handleBookingSuccess = (result) => {
        setBookingResult(result);
        setStep(5);
    };

    const handleReset = () => {
        setStep(1);
        setService(null);
        setSelectedDate(null);
        setSelectedTime(null);
        setBookingResult(null);
    };

    return (
        <div className="app-container">
            <div className="app-header">
                <img src={logo} alt="Colizeum Register" className="app-logo" />
            </div>

            {step <= 4 && (
                <Stepper steps={STEPS} current={step} onStepClick={goToStep} />
            )}

            {step === 1 && <StepService onSelect={handleServiceSelect} />}
            {step === 2 && service && (
                <StepDate
                    service={service}
                    onSelect={handleDateSelect}
                    onBack={() => setStep(1)}
                />
            )}
            {step === 3 && service && selectedDate && (
                <StepTime
                    service={service}
                    date={selectedDate}
                    onSelect={handleTimeSelect}
                    onBack={() => setStep(2)}
                />
            )}
            {step === 4 && service && selectedDate && selectedTime && (
                <StepForm
                    service={service}
                    date={selectedDate}
                    time={selectedTime}
                    onSuccess={handleBookingSuccess}
                    onBack={() => setStep(3)}
                />
            )}
            {step === 5 && (
                <SuccessPage
                    booking={bookingResult}
                    service={service}
                    onReset={handleReset}
                />
            )}
        </div>
    );
}
